// Site-wide design tokens + the Chakra theme built from them.
// Charts are hand-drawn SVG, so they import the raw tokens below.
import { extendTheme } from "@chakra-ui/react";

// ---- color ----
export const BG = "#0b0b0c";
export const PANEL = "#131315";
export const PANEL2 = "#1b1b1f";
export const INSET = "#0f0f11";
export const GRID = "#26262b";
export const FG = "#f3f2ed";
export const BODY = "#c9c7bf";
export const MUTED = "#8b8981";
export const DIM = "#5c5b56";

export const ACCENT = "#d4ff3f"; // volt — the tennis ball
export const HEAT = "#ff6b3d"; // signal orange
export const BLUE = "#5aa8ff";
export const GOLD = "#ffc65a";
export const VIOLET = "#b49cff";
export const MINT = "#3fe0a0";
export const RED = "#ff4d5e";
export const LIME = ACCENT;

// translucent helpers for washes/borders
export const alpha = (hex, a) => {
  const n = parseInt(hex.slice(1), 16);
  return `rgba(${(n >> 16) & 255}, ${(n >> 8) & 255}, ${n & 255}, ${a})`;
};

// ---- type ----
export const SANS = "'Geist', 'Segoe UI', system-ui, -apple-system, sans-serif";
export const MONO = "'Geist Mono', ui-monospace, 'SFMono-Regular', Menlo, Consolas, monospace";
export const SERIF = "'Instrument Serif', 'Times New Roman', Georgia, serif";

export const EASE = [0.22, 1, 0.36, 1];

const theme = extendTheme({
  config: { initialColorMode: "dark", useSystemColorMode: false },
  fonts: { heading: SANS, body: SANS, mono: MONO },
  colors: {
    volt: {
      50: "#fbffe6",
      100: "#f3ffbf",
      200: "#e9ff8f",
      300: "#ddff5f",
      400: ACCENT,
      500: "#bde62f",
      600: "#97b824",
      700: "#718a1b",
      800: "#4b5c12",
      900: "#262e09",
    },
  },
  styles: {
    global: {
      "html, body": { bg: BG, color: FG },
      body: { fontFeatureSettings: "'ss01', 'tnum' 0" },
      "::selection": { bg: ACCENT, color: BG },
      a: { WebkitTapHighlightColor: "transparent" },
    },
  },
  components: {
    Heading: {
      baseStyle: { color: FG, fontWeight: 600, letterSpacing: "-0.03em" },
    },
    Button: {
      baseStyle: {
        borderRadius: "full",
        fontWeight: 600,
        letterSpacing: "-0.01em",
        transition: "all 0.25s cubic-bezier(0.22, 1, 0.36, 1)",
      },
      variants: {
        volt: {
          bg: ACCENT,
          color: BG,
          _hover: { bg: "#e2ff73", transform: "translateY(-2px)", boxShadow: `0 10px 30px ${alpha(ACCENT, 0.25)}` },
          _active: { bg: "#bde62f", transform: "translateY(0)" },
        },
        line: {
          bg: "transparent",
          color: FG,
          border: `1px solid ${GRID}`,
          _hover: { borderColor: FG, bg: alpha(FG, 0.04) },
          _active: { bg: alpha(FG, 0.08) },
        },
        quiet: {
          bg: PANEL2,
          color: FG,
          _hover: { bg: "#24242a" },
        },
      },
    },
    Tooltip: {
      baseStyle: { bg: PANEL2, color: FG, borderRadius: "md", fontSize: "xs", px: 3, py: 2 },
    },
  },
});

export default theme;
